import { AxiosInstance } from 'axios'
import { AllValidationSubmissions, ValidationSubmission } from './validationSubmission.types'
import { apiPaths } from '@percent/cause-dashboard/services/apiPaths'
import { PBPResponse } from '@percent/cause-dashboard/services/types/pbpResponses.types'

type storeServiceCapabilities = {
  percentClient: AxiosInstance
}

export type ValidationSubmissionSource = 'one_click' | 'smart_apply' | 'native_apply'

export type ValidationSubmissionPartnerFields = {
  phone?: string
}

export const storeService = ({ percentClient }: storeServiceCapabilities) => ({
  getValidationSubmission: (validationSubmissionSourceId: string) =>
    percentClient.get<PBPResponse<ValidationSubmission>>(
      `${apiPaths.v1StoreApplications}/${validationSubmissionSourceId}`
    ),
  getValidationSubmissions: ({ accountId, organisationId }: { accountId?: string; organisationId?: string | null }) =>
    percentClient.get<AllValidationSubmissions>(`${apiPaths.v1StoreApplications}`, {
      params: { accountId, organisationId }
    }),
  createValidationSubmissions: ({
    accountId,
    partners,
    organisationId,
    names,
    partnerFields,
    source,
    experimentVariant,
    token
  }: {
    accountId: string
    partners: { partnerId: string; configurationId: string }[]
    organisationId?: string
    names?: { firstName: string; lastName: string }
    partnerFields?: ValidationSubmissionPartnerFields
    source?: ValidationSubmissionSource
    experimentVariant?: string
    token?: string
  }) =>
    percentClient.post(apiPaths.v1StoreApplications, {
      accountId,
      partners,
      organisationId,
      names,
      partnerFields,
      source,
      experimentVariant,
      token
    })
})
